import React from 'react';
import { ArrowRight } from 'lucide-react';
import { colors, spacing, typography, borders } from '../../../../tokens';

interface SwapStepsProps {
  currentStep: number;
}

export const SwapSteps: React.FC<SwapStepsProps> = ({ currentStep }) => {
  return (
    <div>
      <style>{`
        @media (max-width: 500px) {
          .swap-steps-container {
            flex-direction: column !important;
            align-items: stretch !important;
          }
          .swap-steps-arrow {
            transform: rotate(90deg);
            margin: ${spacing.xs} 0;
          }
        }
      `}</style>
      <div
        className="swap-steps-container"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: spacing.md,
          marginBottom: spacing.lg,
        }}
      >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: spacing.sm,
          padding: `${spacing.sm} ${spacing.md}`,
          borderRadius: borders.component.button.radius,
          backgroundColor: currentStep >= 1 ? colors.brand.purple.base : colors.background.secondary.default,
          color: currentStep >= 1 ? colors.neutral.white : colors.text.muted.default,
          fontSize: typography.fontSize.sm,
          fontWeight: typography.fontWeight.medium,
        }}
      >
        <span>1. Connect</span>
      </div>
      <ArrowRight className="swap-steps-arrow" size={16} color={colors.text.muted.default} />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: spacing.sm,
          padding: `${spacing.sm} ${spacing.md}`,
          borderRadius: borders.component.button.radius,
          backgroundColor: currentStep >= 2 ? colors.brand.purple.base : colors.background.secondary.default,
          color: currentStep >= 2 ? colors.neutral.white : colors.text.muted.default,
          fontSize: typography.fontSize.sm,
          fontWeight: typography.fontWeight.medium,
        }}
      >
        <span>2. Network</span>
      </div>
      <ArrowRight className="swap-steps-arrow" size={16} color={colors.text.muted.default} />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: spacing.sm,
          padding: `${spacing.sm} ${spacing.md}`,
          borderRadius: borders.component.button.radius,
          backgroundColor: currentStep >= 3 ? colors.brand.purple.base : colors.background.secondary.default,
          color: currentStep >= 3 ? colors.neutral.white : colors.text.muted.default,
          fontSize: typography.fontSize.sm,
          fontWeight: typography.fontWeight.medium,
        }}
      >
        <span>3. Sign</span>
      </div>
      <ArrowRight className="swap-steps-arrow" size={16} color={colors.text.muted.default} />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: spacing.sm,
          padding: `${spacing.sm} ${spacing.md}`,
          borderRadius: borders.component.button.radius,
          backgroundColor: currentStep >= 4 ? colors.brand.purple.base : colors.background.secondary.default,
          color: currentStep >= 4 ? colors.neutral.white : colors.text.muted.default,
          fontSize: typography.fontSize.sm,
          fontWeight: typography.fontWeight.medium,
        }}
      >
        <span>4. Swap</span>
      </div>
      </div>
    </div>
  );
};
